import React, { useState, useRef, useEffect } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import "../Admin/ProfilePage.css";
import SearchIcon from "@mui/icons-material/Search";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Swal from "sweetalert2";
import IconButton from "@material-ui/core/IconButton";

import {
  checkVendor,
  createVendor,
  getAddressFromPincode,
  getBankDetails,
  getBankName,
  getBlock,
  getDistrict,
  getFY,
  getGPbyBlock,
  getVendorByAccount,
} from "../../api/User";
import logo from "../../images/logo192.png";
import loader from "../../images/ajax-loader.gif";
import DSCValidationPage from "../DSCValidation";

function VendorRegistration({ token, userDetail, userData }) {
  const role = userDetail?.role_id;
  const id = userDetail?.user_id;
  const [districtData, setDistrictData] = useState([]);
  const [districtType, setDistrictType] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockData, setBlockData] = useState([]);
  const [blockType, setBlockType] = useState("");
  const [GPType, setGPType] = useState("");
  const [blockName, setBlockName] = useState("");
  const [GPData, setGPData] = useState([]);
  const [GPName, setGPName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValueName, setSelectedValueName] = useState("");
  const [loadingBlock, setLoadingBlock] = useState(false);
  const [bankAccount, setBankAccount] = useState("");
  const [emailError, setEmailError] = useState("");
  const [panError, setPanError] = useState("");
  const [msmeError, setMsmeError] = useState("");
  const [tanError, setTanError] = useState("");
  const [pfmsError, setPfmsError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [gstError, setGstError] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [ifscError, setIfscError] = useState("");
  const [formData, setFormData] = useState({
    role: role,
    vendor_category: "",
    email: "",
    pan_number: "",
    msme_registered: "",
    msme_number: 0,
    tan_number: "",
    vendor_name: "",
    mobile_number: "",
    pfms_id: "",
    gst_registration: "",
    gst_number: "",
    pincode: "",
    city: "",
    state: "",
    country: "",
    ifsc_code: "",
    bank_name: "",
    branch_name: "",
    account_number: "",
    maker_name: "",
    v_registered: "",
    district: districtType,
    block: blockType,
    village: GPName,
    created_by: "",
    updated_by: "",
    vr_source: "",
    user_id: id,
    cancelled_check_image: "",
    pan_image: "",
    gst_certificate: "",
    msme_register: "",
    registered_address: "",
    account_number_reenter: "",
  });
  const [showInput, setShowInput] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [accountNumber, setAccountNumber] = useState("");
  const [vendorDetails, setVendorDetails] = useState({});
  const [showpage, setShowPage] = useState(false);
  const [showModal, setshowModal] = useState(true);
  const [bankName, setBankName] = useState([]);
  const [vendorCode, setVendorCode] = useState("");
  const [venderBankDetailsByIFSC, setVenderBankDetailsByIFSC] = useState("");
  const tableRef = useRef(null);
  const formRef = useRef(null);

  useEffect(() => {
    const options = [];
    if (role === 6 || role === 7) {
      options.push("gp");
      setSelectedValue("gp");
      setSelectedValueName("Gram Panchayat");
      setIsReadonly(true);
    } else if (role === 8 || role === 9) {
      options.push("ps");
      setSelectedValue("ps");
      setSelectedValueName("Panchayat Samiti");
      setIsReadonly(true);
    } else if (role === 10 || role === 11) {
      options.push("zp");
      setSelectedValue("zp");
      setSelectedValueName("Zila Parishad");
      setIsReadonly(true);
    } else {
      options.push("sab", "gp", "ps", "zp");
      setSelectedValue("");
      setIsReadonly(false);
    }
    setVisibleOptions(options);
  }, [role]);

  const fetchDistrictData = async () => {
    try {
      const res = await getDistrict(
        token,
        userDetail.role_id,
        userDetail.user_id
      );
      setDistrictData(res.data);

      if (
        res.data.length > 0 &&
        (role === 6 ||
          role === 7 ||
          role === 8 ||
          role === 9 ||
          role === 10 ||
          role === 11)
      ) {
        setDistrictType(res.data[0].district_code);
        formData.district = res.data[0].district_code;
        setDistrictName(res.data[0].district_name);
        fetchBlockData(res.data[0].district_code);
        if (res.data.length > 1) {
          setIsReadonly(false);
        }
      }
    } catch (error) {
      console.error("Error fetching district data:", error);
    }
  };

  const fetchBlockData = async (districtCode) => {
    setLoadingBlock(true);
    const data = {
      role: userDetail.role_id,
      id: userDetail.user_id,
      district: districtCode,
    };

    try {
      const res = await getBlock(token, data);
      setBlockData(res.user);
      if (res.user.length > 0 && [6, 7, 8, 9, 10, 11].includes(role)) {
        setBlockType(res.user[0].block_code);
        setFormData((prev) => ({
          ...prev,
          block: res.user[0].block_code,
        }));
        setBlockName(res.user[0].block_name);
        console.log("Block Type set to:", res.user[0].block_code);
        console.log("Block Type set to:", res.user);
        setIsReadonly(true);
        fetchVillageData(res.user[0].block_code, data.district);
      }
    } catch (error) {
      console.error("Error fetching block data:", error);
    }
  };

  const fetchVillageData = async (blockcode, district_code) => {
    setLoadingBlock(true);

    const data1 = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: district_code,
      block_code: blockcode,
    };

    try {
      await getGPbyBlock(token, data1)
        .then((res) => {
          setGPData(res.data);

          setIsReadonly(true);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching block data:", error);
    } finally {
      setLoadingBlock(false);
    }
  };

  const handleEntityChange = async (e) => {
    const newValue = e?.target?.value || selectedValue;
    setSelectedValue(newValue);
    await fetchDistrictData();
  };

  useEffect(() => {
    if (selectedValue) {
      handleEntityChange();
    }
    // handleBankName();
  }, [selectedValue]);

  const handleDistrictChange = async (e) => {
    setLoading(true);
    setDistrictType(e.target.value);
    formData.district = e.target.value;
    setDistrictName(e.target.options[e.target.selectedIndex].text);
    const data = {
      role: userDetail.role_id,
      id: userDetail.user_id,
      district: e.target.value,
    };
    if (role == 8 || role == 6) {
      try {
        await getBlock(token, data)
          .then((res) => {
            setBlockData(res.user);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBlockChange = async (e) => {
    setLoading(true);
    setBlockType(e.target.value);
    formData.block = e.target.value;
    setBlockName(e.target.options[e.target.selectedIndex].text);

    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: districtType,
      block_code: e.target.value,
    };
    if (role == 6) {
      try {
        await getGPbyBlock(token, data)
          .then((res) => {
            setGPData(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const handleGPChange = async (e) => {
    setGPName(e.target.value);
    setGPType(e.target.value);
    console.log("village:", e.target.value);
    const data = {
      role_id: role,
      id: id,
      block_code: blockType,
      VillageId: e.target.value,
    };
    setFormData((prevFormData) => ({
      ...prevFormData,
      district: districtType,
      block: blockType,
      village: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    if (role == 6 || role == 7) {
    if (!GPName) {
      Swal.fire({
        title: "Validation Error",
        text: "Please select  Gram Panchayat.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

  }
    const formDataObject = new FormData();
    for (const key in formData) {
      formDataObject.append(key, formData[key]);
    }
    try {
      const res = await createVendor(token, formData);
      console.log(res.data.status);
      if (res.data.status == "success") {
        console.log("Vendor created successfully:", res.message);
        Swal.fire({
          title: "Vendor created successfully",
          text: res.data.message,
          width: 600,
          backdrop: `
            rgba(211, 211, 211, 0.4)
            no-repeat
          `,
        }).then(() => {
          window.location.reload();
          if (formRef.current) {
            formRef.current.reset();
          }
        });
      } else {
        Swal.fire({
          title: res.data.status,
          text: res.data.message,
          width: 600,
          padding: "3em",
          color: "#dc3545",
          background: "white",
          backdrop: `
            rgba(211, 211, 211, 0.4)
            no-repeat
          `,
          customClass: {
            confirmButton: "swal2-danger",
          },
        });
        console.error(
          "Failed to create vendor:",
          res ? res.message : "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error creating vendor:", error);
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "mobile_number") {
      // Validate mobile number
      const isValidMobile = validateMobile(value);
      setMobileError(isValidMobile ? "" : "Invalid mobile number format");
    }

    if (name === "msme_registered" || name === "gst_registration") {
      emptyInputs(e);
    }
    const upperCaseValue = value.toUpperCase();

    if (name === "pan_number") {
      // Check if the PAN number exceeds 10 characters
      if (upperCaseValue.length > 10) {
        setPanError("PAN should not exceed 10 characters");
      } else if (!validatePan(upperCaseValue)) {
        // Validate the PAN format
        setPanError("PAN should be in the format AAAAA0000A");
      } else {
        // If both checks pass, clear the error
        setPanError("");
      }

      // Call the function to check vendor by PAN
      checkVendorByPan(e);
    }
    if (name === "account_number") {
      checkVendorByAccount(e);
    }
    if (name === "email") {
      setEmailError(validateEmail(value) ? "" : "Invalid email format");
    } else if (name === "msme_number") {
      setMsmeError(validateMsme(value) ? "" : "Invalid MSME number format");
    } else if (name === "tan_number") {
      setTanError(validateTan(value) ? "" : "Invalid TAN");
    } else if (name === "gst_number") {
      setGstError(validateGst(value) ? "" : "Invalid GST number format");
    } else if (name === "pincode") {
      if (value.length === 6) {
        const data = { pincode: value };
        try {
          const res = await getAddressFromPincode(token, data);
          console.log(res);

          if (res && res.PostOffice && res.PostOffice.length > 0) {
            const postOfficeData = res.PostOffice[0];

            setFormData((prev) => ({
              ...prev,
              city: postOfficeData.District,
              state: postOfficeData.State,
              country: postOfficeData.Country,
            }));
          }
        } catch (error) {
          console.error("Error fetching address details: ", error);
        }
        setPincodeError(validatePincode(value) ? "" : "Invalid pincode format");
      } else if (value.length === 0) {
        setFormData((prev) => ({
          ...prev,
          city: "",
          state: "",
          country: "",
        }));
        setPincodeError("");
      }
    } else if (name === "ifsc_code") {
      if (value.length === 11) {
        const data = { ifsc: value };
        await getBankDetails(token, data).then((res) => {
          setVenderBankDetailsByIFSC(res);
          console.log(res);
        });
      }
      setIfscError(validateIfsc(value) ? "" : "Invalid IFSC code format");
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePan = (pan_number) => {
    const re = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return re.test(String(pan_number).toUpperCase());
  };
  const validateMsme = (msme_number) => {
    const re = /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/;
    return re.test(msme_number);
  };

  const validateTan = (tan) => {
    // const re = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
    // return re.test(tan.toUpperCase());
    if (tan == "" || tan == null) {
      return false;
    } else {
      return true;
    }
  };

  const validateMobile = (mobile_number) => {
    const strNumber = mobile_number.toString();
    const re = /^[6-9][0-9]{9}$/;
    const allSameDigits = /^(\d)\1{9}$/;
    return re.test(strNumber) && !allSameDigits.test(strNumber);
  };

  const validatePfms = (pfms) => {
    // const re = /^[A-Za-z0-9]{12}$/;
    // return re.test(pfms);
    if (pfms == "" || pfms == null) {
      return false;
    } else {
      return true;
    }
  };
  const validateGst = (gst_number) => {
    const re = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z1-9]{1}[Z]{1}[A-Z0-9]{1}$/;
    return re.test(gst_number);
  };
  const validatePincode = (pincode) => {
    const re = /^[1-9][0-9]{5}$/;
    return re.test(pincode);
  };
  const validateIfsc = (ifsc_code) => {
    if (ifsc_code.length !== 11) {
      return false;
    }

    const re = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    return re.test(ifsc_code.toUpperCase());
  };

  const handleAccount = (e, a) => {
    console.log(e.target.value, a);
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setIsSaveDisabled(
      (formData.account_number || vendorDetails.account_number) !=
        e.target.value
    );
    // setIsSaveDisabled(true);
  };

  const emptyInputs = (e) => {
    if (
      e.target.name == "msme_registered" &&
      e.target.value == "unregistered"
    ) {
      console.log("unregistered", formData.msme_number);
      formData.msme_number = "";
    }
    if (
      e.target.name == "gst_registration" &&
      e.target.value == "unregistered"
    ) {
      console.log("unregistered", formData.msme_number);
      formData.gst_number = "";
    }
  };
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setShowInput(selectedValue === "yes");
  };

  const saveVendorCode = (e) => {
    setVendorCode(e.target.value);
  };
  const getVendorDetailByAccountNumber = async () => {
    setAccountNumber(vendorCode);
    // setIsSaveDisabled(true);
    console.log(vendorCode);

    const data = {
      vendor_code: vendorCode,
    };
    try {
      setLoading(true);
      const res = await getVendorByAccount(token, data);
      if (res.data && res.data.length > 0 && res.data[0]) {
        console.log(res.data[0]);
        setVendorDetails(res.data[0]);
      } else {
        console.log("There is no vendor for that account number");
        alert("There is no vendor for that account number");
      }
      setFormData((prevFormData) => ({
        ...prevFormData,
        role: role,
        vendor_category:
          res.data[0] && res.data[0].vendor_category
            ? res.data[0].vendor_category
            : "",
        email: res.data[0] && res.data[0].email ? res.data[0].email : "",
        pan: res.data[0] && res.data[0].pan ? res.data[0].pan : "",
        msme_registered:
          res.data[0] && res.data[0].msme_registered
            ? res.data[0].msme_registered
            : "",
        msme_number:
          res.data[0] && res.data[0].msme_number ? res.data[0].msme_number : "",
        tan: res.data[0] && res.data[0].tan ? res.data[0].tan : "",
        vendor_name:
          res.data[0] && res.data[0].vendor_name ? res.data[0].vendor_name : "",
        mobile_number:
          res.data[0] && res.data[0].mobile_number
            ? res.data[0].mobile_number
            : "",
        pfms_id: res.data[0] && res.data[0].pfms_id ? res.data[0].pfms_id : "",
        gst_registration:
          res.data[0] && res.data[0].gst_registration
            ? res.data[0].gst_registration
            : "",
        gst_number:
          res.data[0] && res.data[0].gst_number ? res.data[0].gst_number : "",
        pincode: res.data[0] && res.data[0].pincode ? res.data[0].pincode : "",
        city: res.data[0] && res.data[0].city ? res.data[0].city : "",
        state: res.data[0] && res.data[0].state ? res.data[0].state : "",
        country: res.data[0] && res.data[0].country ? res.data[0].country : "",
        ifsc_code: res.data[0] && res.data[0].ifsc ? res.data[0].ifsc : "",
        bank_name:
          res.data[0] && res.data[0].bank_name ? res.data[0].bank_name : "",
        branch_name:
          res.data[0] && res.data[0].branch_name ? res.data[0].branch_name : "",
        account_number:
          res.data[0] && res.data[0].account_number
            ? res.data[0].account_number
            : "",
        maker_name:
          res.data[0] && res.data[0].maker_name ? res.data[0].maker_name : "",
        v_registered:
          res.data[0] && res.data[0].v_registered
            ? res.data[0].v_registered
            : "",
        // district:
        //   res.data[0] && res.data[0].district
        //     ? res.data[0].district
        //     : districtType,
        // block:
        //   res.data[0] && res.data[0].block
        //     ? res.data[0].block
        //     : blockType,
        // village:
        //   res.data[0] && res.data[0].village
        //     ? res.data[0].village
        //     : GPType,
        created_by:
          res.data[0] && res.data[0].created_by ? res.data[0].created_by : "",
        updated_by:
          res.data[0] && res.data[0].updated_by ? res.data[0].updated_by : "",
        vr_source:
          res.data[0] && res.data[0].vr_source ? res.data[0].vr_source : "",
        user_id: res.data[0] && res.data[0].user_id ? res.data[0].user_id : id,
        cancelled_check_image:
          res.data[0] && res.data[0].cancelled_check_image
            ? res.data[0].cancelled_check_image
            : "",
        pan_image:
          res.data[0] && res.data[0].pan_image ? res.data[0].pan_image : "",
        gst_certificate:
          res.data[0] && res.data[0].gst_certificate
            ? res.data[0].gst_certificate
            : "",
        msme_register:
          res.data[0] && res.data[0].msme_register
            ? res.data[0].msme_register
            : "",
        registered_address:
          res.data[0] && res.data[0].registered_address
            ? res.data[0].registered_address
            : "",
        account_number_reenter:
          res.data[0] && res.data[0].account_number
            ? res.data[0].account_number
            : "",
      }));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const checkVendorByPan = async (e) => {
    const value = e.target.value;
    const data = {
      account_number: "",
      pan_card: value,
    };
    if (value.length == 10) {
      try {
        const res = await checkVendor(token, data);
        const message = res.message;
        Swal.fire({
          title: message,
          width: 600,
          padding: "3em",
          color: "#dc3545",
          background: "white",
          backdrop: `
        rgba(211, 211, 211, 0.4)

        no-repeat
      `,
          customClass: {
            confirmButton: "swal2-danger",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            formRef.current.reset();
          }
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const checkVendorByAccount = async (e) => {
    const value = e.target.value;
    const data = {
      account_number: value,
      pan_card: "",
    };
    if (value.length >= 11 && value.length <= 16) {
      try {
        const res = await checkVendor(token, data);
        const message = res.message;
        Swal.fire({
          title: message,
          width: 600,
          padding: "3em",
          color: "#dc3545",
          background: "white",
          backdrop: `
        rgba(211, 211, 211, 0.4)

        no-repeat
      `,
          customClass: {
            confirmButton: "swal2-danger",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            formRef.current.reset();
          }
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleShowPage = () => {
    setshowModal(false);
    setShowPage(true);
  };
  const handleBankName = async () => {
    setLoading(true);
    try {
      const res = await getBankName(token);
      if (res.status == "success") {
        setBankName(res.data);
        setLoading(false);
        console.log(res.data[0]);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      {showModal && (
        <DSCValidationPage
          token={token}
          userData={userData}
          Type={"VenderRegistrationMaker"}
          show={handleShowPage}
          userDetail={userDetail}
        />
      )}
      {showpage && (
        <div>
          <div
            id="loading-coupon"
            style={{ display: loading ? "block" : "none" }}
          >
            <img id="loading-image" src={loader} alt="Loading..." />
          </div>
          <div className="container-fluid col px-2 px-md-4">
            <div className="my-5 col-12 d-flex justify-content-between align-items-center">
              <h5>
                <strong>Vendor Registration</strong>
              </h5>
            </div>
            <form className="filter" id="myform">
              <div className="row align-items-end mb-4">
                <div className="col-3">
                  <label htmlFor="type" className="form-label">
                    Entity {<span style={{ color: "red" }}>*</span>}{" "}
                  </label>
                  {role == 6 || role == 7 || role == 8 ? (
                    <input
                      name="type"
                      id="type"
                      className="form-control"
                      value={selectedValueName}
                      onChange={handleEntityChange}
                      disabled={isReadonly}
                      // required
                    />
                  ) : (
                    <select
                      name="type"
                      id="type"
                      className="type form-select"
                      value={selectedValue}
                      onChange={handleEntityChange}
                      disabled={isReadonly}
                    >
                      <option value="" disabled>
                        Select Type
                      </option>
                      {visibleOptions.includes("sab") && (
                        <option value="sab">All</option>
                      )}
                      {visibleOptions.includes("gp") && (
                        <option value="gp">Gram Panchayat</option>
                      )}
                      {visibleOptions.includes("ps") && (
                        <option value="ps">Panchayat Samiti</option>
                      )}
                      {visibleOptions.includes("zp") && (
                        <option value="zp">Zila Parishad</option>
                      )}
                      {visibleOptions.includes("zp") && (
                        <option value="zp">District</option>
                      )}
                    </select>
                  )}
                </div>
              </div>
              <div className="row d-flex justify-content-between">
                <div className="col-sm-4" id="div1">
                  <label className="form-label" style={{ fontSize: "18px" }}>
                    District {<span style={{ color: "red" }}>*</span>}
                  </label>
                  {districtData.length == 1 ? (
                    <input
                      name="district"
                      className="form-control"
                      value={districtName}
                      onChange={handleDistrictChange}
                      disabled={isReadonly}
                      // required
                    />
                  ) : (
                    <select
                      name="district"
                      className="common-input form-select"
                      value={districtType}
                      onChange={handleDistrictChange}
                      // disabled={isReadonly}
                      // required
                    >
                      <option value="" disabled>
                        Select District
                      </option>
                      {(role === 1 ||
                        role === 2 ||
                        role === 3 ||
                        role === 4 ||
                        role === 19 ||
                        role === 20 ||
                        role === 22) && <option value="all">All</option>}

                      {districtData?.map((district, index) => (
                        <option key={index} value={district.district_code}>
                          {district.district_name}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
                {role == 10 ? (
                  ""
                ) : (
                  <div className="col-md-4" id="div2">
                    <label className="form-label" style={{ fontSize: "18px" }}>
                      Block {<span style={{ color: "red" }}>*</span>}
                    </label>
                    {blockData?.length == 1 ? (
                      <input
                        name="block"
                        className="form-control"
                        type="text"
                        value={blockData[0]?.block_name}
                        disabled={isReadonly}
                      />
                    ) : (
                      <select
                        name="block"
                        className="common-input form-select"
                        onChange={handleBlockChange}
                      >
                        <option value="" selected disabled>
                          {" "}
                          Select Block
                        </option>

                        {blockData?.map((block, index) => (
                          <option key={index} value={block.block_code}>
                            {block.block_name}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                )}
                {role == 8 || role == 10 ? (
                  ""
                ) : (
                  <div className="col-md-4">
                    <label className="form-label" style={{ fontSize: "18px" }}>
                      Gram Panchayat {<span style={{ color: "red" }}>*</span>}
                    </label>
                    <select
                      name="gp"
                      className="common-input form-select"
                      value={GPName}
                      onChange={handleGPChange}
                       required
                    >
                      <option value="" disabled>
                        Select Gram Panchayat
                      </option>
                      {GPData?.map((gp, index) => (
                        <option key={index} value={gp.VillageId}>
                          {gp.VillageName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <img
                  src={logo}
                  alt="Panchayat Logo"
                  style={{ display: "none" }}
                />
              </div>
            </form>
            <div className="mt-3">
              <h5 style={{ color: "red" }}>
                You can now search vendor by account number.
              </h5>
            </div>
            <div className="row mt-2">
              <form ref={formRef} className="filter" id="myform">
                <div className="col align-items-center">
                  <div className="col-md-12"></div>
                  <div className="row">
                    <div className="col-md-3 mt-2 d-flex align-items-center">
                      <label className="form-label align-items-center">
                        Vendor already Registered on portal?
                      </label>
                    </div>
                    <div className="col-md-2 d-flex align-items-center">
                      <select
                        name="selectOption"
                        className="form-select"
                        onChange={handleSelectChange}
                        required
                      >
                        {/* <option value="no_value">Select Option</option> */}
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                        
                      </select>
                    </div>
                    <div className="col-md-3 mt-2 d-flex align-items-center">
                      {showInput && (
                        <label className="form-label">
                          Enter Account Number to search
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      )}
                    </div>
                    {showInput && (
                      <div className="col-md-4 mt-2 d-flex align-items-center">
                        <input
                          onChange={saveVendorCode}
                          type="number"
                          name="vendor_account"
                          className="form-control"
                          maxLength={16}
                        />
                        <IconButton onClick={getVendorDetailByAccountNumber}>
                          <SearchIcon />
                        </IconButton>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="col px-2 px-md-4">
              <h6
                className="my-3 px-4 col-12 d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "#0d6efd",
                  textAlign: "center",
                  border: "2px ",
                  borderRadius: "10px",
                  color: "white",
                  padding: "10px",
                }}
              >
                Vendor/Client Details
              </h6>
            </div>
            <form
              ref={formRef}
              className="filter mb-5"
              id="myform"
              // onSubmit={handleSubmit}
            >
              <div className="col align-items-center">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label align-items-center">
                        Category Type {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <select
                        name="vendor_category"
                        className="form-select"
                        value={
                          formData.vendor_category ||
                          vendorDetails?.vendor_category
                        }
                        onChange={handleChange}
                        // required
                      >
                        <option value="" disabled selected>
                          Select Organization
                        </option>
                        <option value="HUF">
                          H-HUF(HINDU UNDIVIDED FAMINLY)
                        </option>
                        <option value="INDIVIDUAL">I-INDIVIDUAL</option>
                        <option value="PROPRIETORSHIP">P-PROPRIETORSHIP</option>
                        <option value="COMPANY">C-COMPANY</option>
                        <option value="ASSOCIATON OF PERSONS">
                          A-ASSOCIATON OF PERSONS
                        </option>
                        <option value="BODY OF INDIVIDUAL">
                          B-BODY OF INDIVIDUAL
                        </option>
                        <option value="GOVERNMENT AGENCY">
                          G-GOVERNMENT AGENCY
                        </option>
                        <option value="ARTIFICAL JUDICIAL PERSON">
                          J-ARTIFICAL JUDICIAL PERSON
                        </option>
                        <option value="LABOUR">L-LABOUR</option>
                        <option value="FIRM/LIMITED LIABILITY PARTNERSHIP">
                          F-FIRM/LIMITED LIABILITY PARTNERSHIP
                        </option>
                        <option value="TRUST">T-TRUST</option>
                      </select>
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        Email {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        value={vendorDetails?.email || formData?.email}
                        onChange={handleChange}
                      />
                      {emailError && (
                        <p style={{ color: "red" }}>{emailError}</p>
                      )}
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        PAN{" "}
                        {
                          <span
                            style={{
                              color: "red",
                              display:
                                formData.vendor_category == "INDIVIDUAL" ||
                                formData.vendor_category == "LABOUR"
                                  ? "none"
                                  : "",
                            }}
                          >
                            *
                          </span>
                        }
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="pan_number"
                        className="form-control"
                        value={vendorDetails.pan || formData.pan}
                        onChange={handleChange}
                        maxLength="10"
                        style={{ textTransform: "uppercase" }}
                        disabled={
                          formData.vendor_category == "INDIVIDUAL" ||
                          formData.vendor_category == "LABOUR" ||
                          vendorDetails?.vendor_category == "INDIVIDUAL" ||
                          vendorDetails?.vendor_category == "LABOUR"
                        }
                      />
                      {panError && <p style={{ color: "red" }}>{panError}</p>}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-2">
                  <div className="row">
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label align-items-center">
                        MSME Registered{" "}
                        {
                          <span
                            style={{
                              color: "red",
                              display:
                                formData.vendor_category == "INDIVIDUAL" ||
                                formData.vendor_category == "LABOUR"
                                  ? "none"
                                  : "",
                            }}
                          >
                            *
                          </span>
                        }
                      </label>
                    </div>
                    <div className="col-md-2">
                      <select
                        name="msme_registered"
                        className="form-select"
                        value={
                          vendorDetails?.msme_registered ||
                          formData.msme_registered
                        }
                        onChange={handleChange}
                        onClick={emptyInputs}
                        disabled={
                          formData.vendor_category == "INDIVIDUAL" ||
                          formData.vendor_category == "LABOUR"
                        }
                        // required
                      >
                        <option value="" disabled selected>
                          Select MSME
                        </option>
                        <option value="registered">Registered</option>
                        <option value="unregistered">Unregistered</option>
                      </select>
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        MSME no.{" "}
                        {
                          <span
                            style={{
                              color: "red",
                              display:
                                formData.msme_registered !== "registered" ||
                                formData.vendor_category == "INDIVIDUAL" ||
                                formData.vendor_category == "LABOUR"
                                  ? "none"
                                  : "",
                            }}
                          >
                            *
                          </span>
                        }
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="msme_number"
                        className="form-control"
                        value={
                          vendorDetails.msme_number || formData.msme_number
                        }
                        onChange={handleChange}
                        maxLength="20"
                        disabled={
                          vendorDetails?.msme_registered == "unregistered" ||
                          formData.msme_registered != "registered" ||
                          formData.vendor_category == "INDIVIDUAL" ||
                          formData.vendor_category == "LABOUR"
                        }
                      />
                      {(vendorDetails.msme_registered == "registered" ||
                        formData.msme_registered == "registered") &&
                        msmeError && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "1px",
                            }}
                          >
                            {msmeError}
                          </p>
                        )}
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">TAN</label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="tan_number"
                        className="form-control"
                        value={vendorDetails.tan || formData.tan_number}
                        onChange={handleChange}
                        maxLength="10"
                      />
                      {tanError && <p style={{ color: "red" }}>{tanError}</p>}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-2">
                  <div className="row">
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label align-items-center">
                        Vendor Name {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="vendor_name"
                        className="form-control"
                        value={
                          vendorDetails.vendor_name || formData.vendor_name
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        Mobile no. {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="mobile_number"
                        className="form-control"
                        value={
                          vendorDetails.mobile_number || formData.mobile_number
                        }
                        onChange={handleChange}
                        maxLength={10}
                        onKeyPress={(e) => {
                          const inputValue = e.target.value;
                          const key = e.key;

                          if (!/[0-9]/.test(key)) {
                            e.preventDefault();
                            return;
                          }

                          if (inputValue.length === 0 && !/[6-9]/.test(key)) {
                            e.preventDefault();
                            return;
                          }

                          if (inputValue.length >= 10) {
                            e.preventDefault();
                          }
                        }}
                      />

                      {mobileError && (
                        <p style={{ color: "red" }}>{mobileError}</p>
                      )}
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">PFMS Id</label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="pfms_id"
                        className="form-control"
                        value={vendorDetails.pfms_id || formData.pfms_id}
                        onChange={handleChange}
                        maxLength="12"
                      />
                      {pfmsError && <p style={{ color: "red" }}>{pfmsError}</p>}
                    </div>
                  </div>
                </div>
                <div className="col px-2 px-md-4">
                  <h6
                    className="my-3 px-4 col-12 d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "#0d6efd",
                      textAlign: "center",
                      border: "2px ",
                      borderRadius: "10px",
                      color: "white",
                      padding: "10px",
                    }}
                  >
                    Registered Office and GST Details
                  </h6>
                </div>
                <div className="col-md-12 mt-2">
                  <div className="row">
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label align-items-center">
                        GST Registration{" "}
                        {
                          <span
                            style={{
                              color: "red",
                              display:
                                formData.vendor_category == "INDIVIDUAL" ||
                                formData.vendor_category == "LABOUR"
                                  ? "none"
                                  : "",
                            }}
                          >
                            *
                          </span>
                        }
                      </label>
                    </div>
                    <div className="col-md-2">
                      <select
                        name="gst_registration"
                        className="form-select"
                        value={
                          vendorDetails.gst_register ||
                          formData.gst_registration
                        }
                        onChange={handleChange}
                        onClick={emptyInputs}
                        disabled={
                          formData.vendor_category == "INDIVIDUAL" ||
                          formData.vendor_category == "LABOUR"
                        }
                        // required
                      >
                        <option value="" disabled selected>
                          Select GST type
                        </option>
                        <option value="registered">Registered</option>
                        <option value="unregistered">Unregistered</option>
                      </select>
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        GST no.{" "}
                        {
                          <span
                            style={{
                              color: "red",
                              display:
                                formData.gst_registration !== "registered" ||
                                formData.vendor_category == "INDIVIDUAL" ||
                                formData.vendor_category == "LABOUR"
                                  ? "none"
                                  : "",
                            }}
                          >
                            *
                          </span>
                        }
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="gst_number"
                        className="form-control"
                        value={vendorDetails.gst_number || formData.gst_number}
                        onChange={handleChange}
                        maxLength="15"
                        disabled={
                          formData.gst_registration !== "registered" ||
                          formData.vendor_category == "INDIVIDUAL" ||
                          formData.vendor_category == "LABOUR"
                        }
                      />
                      {formData.gst_registration == "registered" &&
                        gstError && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "1px",
                            }}
                          >
                            {gstError}
                          </p>
                        )}
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        Pin Code {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text" 
                        name="pincode"
                        className="form-control"
                        value={vendorDetails.pincode || formData.pincode}
                        onChange={handleChange}
                        maxLength="6"
                        onKeyPress={(e) => {
                          const key = e.key;
                          if (!/[0-9]/.test(key)) {
                            e.preventDefault(); 
                            return;
                          }

                          const inputValue = e.target.value;
                          if (inputValue.length >= 6) {
                            e.preventDefault(); 
                          }
                        }}
                      />
                      {pincodeError && (
                        <p style={{ color: "red" }}>{pincodeError}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-2">
                  <div className="row">
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label align-items-center">
                        City {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="city"
                        className="form-control"
                        value={vendorDetails.city || formData.city}
                        onChange={handleChange}
                       // disabled={!!(vendorDetails.city || formData.city)}
                      disabled
                      />
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        State {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="state"
                        className="form-control"
                        value={vendorDetails.state || formData.state}
                        onChange={handleChange}
                      //  disabled={!!(vendorDetails.state || formData.state)}
                     disabled
                     />
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        Country {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="country"
                        className="form-control"
                        value={vendorDetails.country || formData.country}
                        onChange={handleChange}
                       // disabled={!!(vendorDetails.country || formData.country)}
                     disabled
                     />
                    </div>
                  </div>
                </div>
                <div className="col px-2 px-md-4">
                  <h6
                    className="my-3 px-4 col-12 d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "#0d6efd",
                      textAlign: "center",
                      border: "2px ",
                      borderRadius: "10px",
                      color: "white",
                      padding: "10px",
                    }}
                  >
                    Sales Office Details
                  </h6>
                </div>

                <div ref={tableRef} className="mb-5">
                  <table
                    className="table table-striped table-bordered justify-content-center align-items-center"
                    aria-label="simple table"
                  >
                    <thead>
                      <tr
                        style={{
                          fontSize: "16px",
                          textAlign: "center",
                          backgroundColor: "#f2f2f2",
                        }}
                      ></tr>
                      <tr
                        style={{ fontSize: "16px", backgroundColor: "#00bfff" }}
                      >
                        <th style={{ whiteSpace: "nowrap" }}>IFSC Code</th>
                        <th style={{ whiteSpace: "nowrap" }}>Bank Name</th>
                        <th style={{ whiteSpace: "nowrap" }}>Branch Name</th>
                        <th style={{ whiteSpace: "nowrap" }}>
                          Account Holder's Name
                        </th>
                        <th style={{ whiteSpace: "nowrap" }}>Bank A/C No</th>
                        <th style={{ whiteSpace: "nowrap" }}>
                          Re-enter A/C No
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ fontSize: "16px", textAlign: "center" }}>
                        <td>
                          <input
                            type="text"
                            name="ifsc_code"
                            className="form-control"
                            value={vendorDetails.ifsc || formData.ifsc_code}
                            onChange={handleChange}
                            maxLength="11"
                          />
                          {ifscError && (
                            <p style={{ color: "red" }}>{ifscError}</p>
                          )}
                        </td>
                        <td>
                          <input
                            type="text"
                            name="bank_name"
                            className="form-control"
                            value={
                              vendorDetails.bank_name ||
                              formData.bank_name ||
                              venderBankDetailsByIFSC.BANK
                            }
                            onChange={handleChange}
                            disabled
                          />
                          {ifscError && (
                            <p style={{ color: "red" }}>{ifscError}</p>
                          )}
                        </td>

                        <td>
                          <input
                            type="text"
                            name="branch_name"
                            className="form-control"
                            value={
                              vendorDetails.branch_name ||
                              formData.branch_name ||
                              venderBankDetailsByIFSC.BRANCH
                            }
                            onChange={handleChange}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="vendor_name"
                            className="form-control"
                            defaultValue={
                              vendorDetails.vendor_name || formData.vendor_name
                            }
                            onChange={handleChange}
                          />
                        </td>
                        <td>
                          <input
                            type="password"
                            name="account_number"
                            className="form-control"
                            defaultValue={
                              vendorDetails.account_number ||
                              formData.account_number
                            }
                            onChange={handleChange}
                            maxLength={16}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            name="account_number_reenter"
                            className="form-control"
                            onChange={(e) =>
                              handleAccount(e, formData.account_number)
                            }
                            maxLength={16}
                          />
                          <p
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "1px",
                            }}
                          >
                            {(formData?.account_number ||
                              vendorDetails.account_number) !=
                            formData.account_number_reenter
                              ? "Account numbers should be the same."
                              : ""}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row col-12 mt-5 d-flex mx-1 mb-5 justify-content-end">
                <button
                  type="submit"
                  className="btn me-2 col-md-2"
                  onClick={handleSubmit}
                  disabled={
                    vendorDetails.account_number && !isSaveDisabled
                      ? false
                      : !isSaveDisabled &&
                        formData.country !== "" &&
                        formData.city !== "" &&
                        formData.state !== "" &&
                        formData.pincode.length === 6 && 
                        formData.email !== "" &&
                        formData.mobile_number !== "" &&
                        formData.vendor_name !== "" &&
                        formData.vendor_category !== "" &&
                        (formData.vendor_category == "INDIVIDUAL" ||
                        formData.vendor_category == "LABOUR" ||
                        vendorDetails?.vendor_category == "INDIVIDUAL" ||
                        vendorDetails?.vendor_category == "LABOUR"
                          ? true
                          : (formData.msme_registered === "registered"
                              ? formData.msme_number !== ""
                              : true) &&
                            formData.pan_number !== "" &&
                            formData.msme_registered  !== "" &&
                            formData.ifsc_code !== "" &&
                            (formData.gst_registration === "registered"
                              ? formData.gst_number !== ""
                              : true) &&
                            formData.gst_registration !== "")
                      ? false
                      : true
                  }
                >
                  Save
                </button>
                <button type="reset" className="btn me-2 col-md-2">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default VendorRegistration;
